export default {
  namespaced: true,

  state: {
    items: []
  },

  mutations: {
    retrieve(state) {
      if (!state.items.length) {
        window.Ajax.get('/services')
          .then(response => {
            state.items = response.data;
          })
          .catch(err => {});
      }
    }
  },
  getters: {
    all(state) {
      return state.items;
    }
  }
};
